var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('details', {
    staticClass: "share"
  }, [_c('summary', {
    staticClass: "share-trigger"
  }, [_vm._t("default")], 2), _vm._v(" "), _c('div', {
    staticClass: "share-menu"
  }, [_c('div', {
    staticClass: "share-modal"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "share-modal-body"
  }, [_c('div', {
    staticClass: "share-list"
  }, [_c('button', {
    staticClass: "share-button share-button--facebook",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.shareHandler('facebook');
      }
    }
  }, [_c('span', {
    staticClass: "share-button-image"
  }), _c('span', {
    staticClass: "share-button-label"
  }, [_vm._v("facebook")])]), _vm._v(" "), _c('button', {
    staticClass: "share-button share-button--twitter",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.shareHandler('twitter');
      }
    }
  }, [_c('span', {
    staticClass: "share-button-image"
  }), _c('span', {
    staticClass: "share-button-label"
  }, [_vm._v("twitter")])]), _vm._v(" "), _c('button', {
    staticClass: "share-button share-button--line",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.shareHandler('line');
      }
    }
  }, [_c('span', {
    staticClass: "share-button-image"
  }), _c('span', {
    staticClass: "share-button-label"
  }, [_vm._v("line")])]), _vm._v(" "), _c('button', {
    ref: "copylinkTrigger",
    staticClass: "share-button share-button--copylink",
    attrs: {
      "type": "button",
      "data-clipboard-text": _vm.url
    }
  }, [_c('span', {
    staticClass: "share-button-image"
  }), _c('span', {
    staticClass: "share-button-label"
  }, [_vm._v("copylink")])])])]), _vm._v(" "), _c('div', {
    staticClass: "share-modal-footer"
  })]), _vm._v(" "), _c('toast', {
    attrs: {
      "visible": _vm.toastVisible,
      "message": _vm.toastMessage
    }
  })], 1)]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('header', {
    staticClass: "share-modal-header"
  }, [_c('div', {
    staticClass: "share-modal-title"
  }, [_vm._v("share")])]);
}];
export { render, staticRenderFns };